<div class="m-8">
  <p-card class="grid">
    <div class="flex gap-4">
      <button
        pButton
        pRipple
        label="Add User"
        class="p-button"
        (click)="openUpdateUserDialog()"
      ></button>
      <p-autoComplete
        class="search-user"
        [suggestions]="suggestions"
        (completeMethod)="search($event)"
        completeOnFocus="true"
        [dropdown]="true"
        (onSelect)="search($event)"
        (onClear)="search($event)"
        placeholder="Search by email"
      >
      </p-autoComplete>
    </div>
    <p-table
      responsiveLayout="scroll"
      styleClass="p-datatable-striped"
      [metaKeySelection]="true"
      dataKey="code"
      [stripedRows]="true"
      [value]="
        filteredCompanies.length > 0
          ? filteredCompanies
          : userManagementService.companies
      "
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5rem"></th>
          <th>
            <div class="icon-title-th"><label>Company Name</label></div>
          </th>
          <th>
            <div class="icon-title-th"><label>Company Code</label></div>
          </th>
          <th>
            <div class="icon-title-th"><label>User Count</label></div>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-company
        let-i="rowIndex"
        let-expanded="expanded"
      >
        <tr>
          <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="company"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            ></button>
          </td>
          <td>{{ company.name }}</td>
          <td>{{ company.code }}</td>
          <td>{{ companyUserMap[company.code]?.length || 0 }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="expandedrow" let-company>
        <tr>
          <td colspan="12">
            <div
              style="margin-left: 8%"
              *ngIf="
                companyUserMap[company.code]?.length > 0;
                then thenRolesBlock;
                else elseRolesBlock
              "
            ></div>
            <ng-template #thenRolesBlock>
              <p-table [value]="companyUserMap[company.code]">
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                      <div class="icon-title-th"><label>User email</label></div>
                    </th>
                    <th>
                      <div class="icon-title-th"><label>First Name</label></div>
                    </th>
                    <th>
                      <div class="icon-title-th">
                        <label>Family Name</label>
                      </div>
                    </th>
                    <th>
                      <div class="icon-title-th"><label>Role</label></div>
                    </th>
                    <th>
                      <div class="icon-title-th"><label>Products</label></div>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user>
                  <tr>
                    <td>{{ user.email }}</td>
                    <td>{{ user.firstName }}</td>
                    <td>{{ user.familyName }}</td>
                    <div
                      *ngIf="user.role; then thenDisplayRoles; else noRoles"
                    ></div>
                    <ng-template #thenDisplayRoles>
                      <td>
                        {{ user.role }}
                      </td>
                    </ng-template>
                    <ng-template #noRoles>
                      <td>
                        <div class="icon-title-th">
                          No roles have been added yet
                        </div>
                      </td>
                    </ng-template>

                    <div
                      *ngIf="
                        userManagementService.companyMap[
                          company.code
                        ].getRoleProducts(user.role).length > 0;
                        then displayProducts;
                        else noProducts
                      "
                    ></div>
                    <ng-template #displayProducts>
                      <td>
                        <li
                          *ngFor="
                            let product of userManagementService.companyMap[
                              company.code
                            ].getRoleProducts(user.role)
                          "
                        >
                          {{ product }}
                        </li>
                      </td>
                    </ng-template>
                    <ng-template #noProducts>
                      <td>
                        <div class="icon-title-th">--</div>
                      </td>
                    </ng-template>
                    <td>
                      <p-splitButton
                        label="Edit"
                        icon="fa fa-pencil"
                        (onClick)="openUpdateUserDialog(user)"
                        appendTo="body"
                        [model]="buttonItems"
                        (onDropdownClick)="setTargetUser(user)"
                      >
                      </p-splitButton>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-template>
            <ng-template #elseRolesBlock> -- </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>

<p-dialog
  [(visible)]="userDialog"
  [modal]="true"
  [header]="newUser ? 'Create New User' : `Update ${editUser?.email}` "
  id="dialog"
  [draggable]="false"
  [resizable]="true"
  [style]="{ width: '400px' }"
  closeAriaLabel="CloseDialog"
>
  <ng-template pTemplate="content">
    <div class="grid gap-4 grid-cols-1 pt-2">
      <div class="row p-grid">
        <p-floatlabel variant="on">
          <p-autoComplete
            [(ngModel)]="editUser.company"
            [suggestions]="suggestedCompanies"
            (completeMethod)="searchCompanies($event)"
            completeOnFocus="false"
            [dropdown]="true"
            [forceSelection]="true"
            appendTo="body"
            class="w-full"
            field="name"
            (onSelect)="onChangeCompany($event)"
          >
          </p-autoComplete>
          <label>Company Name *</label>
        </p-floatlabel>
      </div>
      <div class="row p-grid">
        <p-floatlabel variant="on">
          <p-select
            appendTo="body"
            [options]="availableRoles"
            [required]="true"
            class="w-full"
            optionLabel="name"
            optionValue="name"
            [(ngModel)]="editUser.role"
          >
          </p-select>
          <label>Role *</label>
        </p-floatlabel>
      </div>
      <div class="row p-grid" *ngIf="newUser">
        <p-floatlabel variant="on">
          <input
            type="text"
            class="w-full"
            pInputText
            (input)="onEmailInput($event)"
            [ngClass]="{ 'ng-invalid': invalidEmail }"
            [(ngModel)]="editUser.email"
          />
          <label>Email *</label>
        </p-floatlabel>
        <small
          aria-label="error-string"
          *ngIf="invalidEmail"
          class="invalid-input-message"
        >
          Invalid email.<br />
        </small>
      </div>
      <div class="row p-grid">
        <p-floatlabel variant="on">
          <input
            type="text"
            class="w-full"
            pInputText
            (input)="onFirstNameInput($event)"
            [ngClass]="{ 'ng-invalid': invalidFirstName }"
            [(ngModel)]="editUser.firstName"
          />
          <label>First Name *</label>
        </p-floatlabel>
        <small
          aria-label="error-string"
          *ngIf="invalidFirstName"
          class="invalid-input-message"
        >
          Can only contain letters, spaces, and hyphens.<br />
          Must begin and end with a letter.<br />
        </small>
      </div>
      <div class="row p-grid">
        <p-floatlabel variant="on">
          <input
            type="text"
            class="w-full"
            pInputText
            (input)="onFamilyNameInput($event)"
            [ngClass]="{ 'ng-invalid': invalidFamilyName }"
            [(ngModel)]="editUser.familyName"
          />
          <label>Family Name *</label>
        </p-floatlabel>
        <small
          aria-label="error-string"
          *ngIf="invalidFamilyName"
          class="invalid-input-message"
        >
          Can only contain letters, spaces, and hyphens.<br />
          Must begin and end with a letter.<br />
        </small>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Cancel"
      class="p-button-outlined"
      (click)="hideDialog()"
    ></button>
    <button
      pButton
      pRipple
      label="Save"
      class="p-button"
      (click)="saveUser()"
      [disabled]="
        !(
          editUser.companyCode &&
          editUser.email &&
          editUser.firstName &&
          editUser.familyName &&
          editUser.role
        ) ||
        invalidEmail ||
        invalidFirstName ||
        invalidFamilyName
      "
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="deletionDialog"
  [modal]="true"
  header="Delete User"
  styleClass="p-fluid"
  id="dialog"
  [draggable]="false"
  [resizable]="true"
  [style]="{ width: '400px' }"
  closeAriaLabel="CloseDialog"
>
  <ng-template pTemplate="content">
    <p>
      Are you sure you want to delete user <b>{{ targetUser.email }}</b
      >?
    </p>
    <p>This action is irreversible.</p>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Cancel"
      class="p-button-outlined p-mr-2"
      (click)="hideDialog()"
    ></button>
    <button
      pButton
      pRipple
      label="Delete"
      class="p-button p-ml-2"
      (click)="deleteUser()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="inviteDialog"
  [modal]="true"
  header="Re-Invite User"
  styleClass="p-fluid"
  id="dialog"
  [draggable]="false"
  [resizable]="true"
  [style]="{ width: '400px' }"
  closeAriaLabel="CloseDialog"
>
  <ng-template pTemplate="content">
    <p>
      Are you sure you want to resend an invitation to
      <b>{{ targetUser.email }}</b
      >?
    </p>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Cancel"
      class="p-button-outlined p-mr-2"
      (click)="hideDialog()"
    ></button>
    <button
      pButton
      pRipple
      label="Send"
      class="p-button p-ml-2"
      (click)="inviteUser()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="resetPasswordDialog"
  [modal]="true"
  header="Reset User Password"
  styleClass="p-fluid"
  id="dialog"
  [draggable]="false"
  [resizable]="true"
  [style]="{ width: '400px' }"
  closeAriaLabel="CloseDialog"
>
  <ng-template pTemplate="content">
    <p>
      Are you sure you want to reset the password of
      <b>{{ targetUser.email }}</b
      >?
    </p>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      label="Cancel"
      class="p-button-outlined p-mr-2"
      (click)="hideDialog()"
    ></button>
    <button
      pButton
      pRipple
      label="Send"
      class="p-button p-ml-2"
      (click)="resetPassword()"
    ></button>
  </ng-template>
</p-dialog>
